module.exports = __webpack_public_path__ + "static/media/All about account settings.221c9764.png";